import extractDomainFromString from "./extractDomainFromString";

export const getTldsFromSession = () => {
  const cartFromSession = JSON.parse(window.sessionStorage.getItem("cart"));
  const tldList = (cartFromSession && cartFromSession.productPrices) || [];

  return (
    [
      ...new Set(
        tldList.map((item) => extractDomainFromString(item.fullDomain).tld),
      ),
    ] || []
  );
};

export const getTldsFromCart = (cartItems) => {
  return (
    [
      ...new Set(
        cartItems.map((item) => extractDomainFromString(item.fullDomain).tld),
      ),
    ] || []
  );
};
